import { render } from "./PageDataPenanganan.vue?vue&type=template&id=08d7bf52&scoped=true"
import script from "./PageDataPenanganan.vue?vue&type=script&lang=js"
export * from "./PageDataPenanganan.vue?vue&type=script&lang=js"

import "./PageDataPenanganan.vue?vue&type=style&index=0&id=08d7bf52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d7bf52"]])

export default __exports__